/*
 * @Author: caiqin.xie
 * @since: 2023-07-20 18:24:05
 * @lastTime: 2023-07-20 18:39:43
 * @LastEditors: caiqin.xie
 * @message: 
 */
import React, {useState} from "react";
import styles from "./index.module.scss";

interface IFaqItem {
  id?: string,
  title: string,
  content: string
}
interface IProps {
  FaqList: IFaqItem,
  className?: string
}

const GameItem = (props: IProps) => { 
  const { FaqList, className} = props
  const [showContent, setShowContent] = useState(false);

  return (
    <div className={`${styles['faq-item']} ${className}`}>
      <div className={styles['faq-top']}>
        <h3 className={styles['faq-title']}>{FaqList.title}</h3>
        {showContent && <i className={styles['arrow-up']} onClick={() => {setShowContent(!showContent)}}></i>}
        {!showContent && <i className={styles['arrow-down']} onClick={() => {setShowContent(!showContent)}}></i>}
      </div>
      {showContent && <p className={styles['faq-content']}>{FaqList.content}</p>}
    </div>
  )
}
export default GameItem 